<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex align-items-center">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 text-center">
              <div>
                <div>
                  <h3 style="color: white">Khuyến mãi</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row post-custom-detail">
          <div class="col-sm-4">
            <h5>Tin tức liên quan</h5>
            <div class="vong-lap-nav" v-for="(tintuc,index) in tintuckhuyenmai" :key="index">
              <!-- <p>{{tintuc.tieude}}</p> -->
              <a @click="MessageID = tintuc.MessageID" v-bind:href="'#/chi-tiet/' + tintuc.MessageID"><span>{{index + 1}}</span>. {{tintuc.MessageTitle}}</a>
              <!-- <a v-bind:href="`#/chi-tiet/${tintuc.postid}`">{{tintuc.tieude}}</a> -->
            </div>
          </div>
          <div class="col-sm-8">
            <div class="vong-lap-noidung" v-for="(tintuc,index) in tintuckhuyenmai" :key="index">
              <div v-if="tintuc.MessageID == MessageID">
                <h5>{{tintuc.MessageTitle}}</h5>
                <!-- <img
                  v-for="(img,index) in tintuckhuyenmai"
                  :key="index"
                  v-bind:src="img.Image"
                  v-if="tintuc.Image == img.Image"
                  class="img-body-detail"
                > -->
                <img
                  v-bind:src="tintuc.Image"
                  v-if="tintuc.Image"
                  class="img-body-detail"
                >
                <span v-html="tintuc.MesssageContent"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import tintuckhuyenmai from "../assets/data/tin-tuc-khuyen-mai.json";
export default {
  name: "ChiTiet",
  data() {
    return {
      tintuckhuyenmai,
      MessageID: this.$route.params.Pid
    };
  },
  methods: {
    parseJson: () => {
      return (tintuckhuyenmai = JSON.parse(tintuckhuyenmai));
    }
  },
  beforeMount() {}
};
</script>
<style scoped>
.post-custom-detail {
  padding-top: 50px;
}
.vong-lap-noidung h3 {
  text-transform: unset;
}
.vong-lap-noidung h5 {
  color: #13b078;
  font-size: 18px;
  font-weight: 600;
}
.img-body-detail {
  width: 100%;
  height: auto;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 20px 0;
}
.vong-lap-noidung p {
  text-align: justify;
}
.vong-lap-nav {
  margin-bottom: 10px;
}
.vong-lap-nav a {
  color: #13b078;
}
.post-custom-detail .col-sm-4 h5 {
  color: #13b078;
  font-weight: 700;
}
</style>